/**
 * @generated SignedSource<<15294d69af78091c09432ba0a1a249fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllWidgetsContent_widget$data = {
  readonly __typename: "WidgetCalendar";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendar_widgetCalendar">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetCalendarOverview";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendarOverview_widget">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetEmployeeLeave";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeLeave_widgetEmployeeLeave">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetEmployeeRoleOverview";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeRoleOverview_widget">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetEmployeeSchedule";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeSchedule_widgetEmployeeSchedule">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetFile";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFile_widgetFile">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetIntegrationFlourishPraise";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetIntegrationPushAppy";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationPushAppy_widgetIntegrationPushAppy">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetIntegrationTurnpike";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpike_widgetIntegrationTurnpike">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetKPI";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetKPI_widgetKPI">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetList";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetList_widgetList">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetNewsfeed";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNewsfeed_widgetNewsfeed">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetNote";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetRoutineOverview";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverview_widgetRoutineOverview">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetRoutinePositivePercentage";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetSignalOverview";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetSignalOverview_widget">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetSpace";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetSpace_widgetSpace">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetTable";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTable_table">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetTaskCollection";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskCollection_widgetTaskCollection">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetTaskSingle";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingle_widgetTaskSingle">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetTeamSchedule";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamSchedule_widget">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetTodoOverview";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverview_widget">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetTodoSummary";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoSummary_widgetTodoSummary">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  readonly __typename: "WidgetWeather";
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeather_widget">;
  readonly " $fragmentType": "AllWidgetsContent_widget";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "AllWidgetsContent_widget";
};
export type AllWidgetsContent_widget$key = {
  readonly " $data"?: AllWidgetsContent_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllWidgetsContent_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllWidgetsContent_widget",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetSpace_widgetSpace"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetSpace",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIntegrationFlourishPraise_widgetIntegrationFlourishPraise"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetIntegrationFlourishPraise",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetFile_widgetFile"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetFile",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamSchedule_widget"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetTeamSchedule",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetEmployeeSchedule_widgetEmployeeSchedule"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetEmployeeSchedule",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetEmployeeLeave_widgetEmployeeLeave"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetEmployeeLeave",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetWeather_widget"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetWeather",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTodoOverview_widget"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetTodoOverview",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetSignalOverview_widget"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetSignalOverview",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetEmployeeRoleOverview_widget"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetEmployeeRoleOverview",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNote_widgetNote"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetNote",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTaskSingle_widgetTaskSingle"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetTaskSingle",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTaskCollection_widgetTaskCollection"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetTaskCollection",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetRoutineOverview_widgetRoutineOverview"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetRoutineOverview",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetRoutinePositivePercentage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTodoSummary_widgetTodoSummary"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetTodoSummary",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetCalendarOverview_widget"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetCalendarOverview",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIntegrationPushAppy_widgetIntegrationPushAppy"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetIntegrationPushAppy",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIntegrationTurnpike_widgetIntegrationTurnpike"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetIntegrationTurnpike",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetCalendar_widgetCalendar"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetCalendar",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetKPI_widgetKPI"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetKPI",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNewsfeed_widgetNewsfeed"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetNewsfeed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetList_widgetList"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetList",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTable_table"
        },
        (v0/*: any*/)
      ],
      "type": "WidgetTable",
      "abstractKey": null
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};
})();

(node as any).hash = "12a2d14fdbad5b37138727d4ce6da723";

export default node;
